import '../Styles/FormMember.css';
import React from "react";
function ChildMember({ keyChild: keyChild, onChildDataReceived: onChildDataReceived }) {
    const [childName, setChildName] = React.useState('');
    const [childDob, setChildDob] = React.useState('');
    const [childGender, setChildGender] = React.useState('Male');
    const handelChildNames = (e) => {
        setChildName(e.target.value);
    };
    const handleChildDateOfBirth = (e) => {
        setChildDob(e.target.value);
    };
    const handleChildGender = (e) => {
        setChildGender(e.target.value);
    };
    const [error, setError] = React.useState('');
    const childButtonClicked = (e) => {
        e.preventDefault();
        if (childName === '') {
            setError('Child name is required');
            return;
        }
        if (childDob === '') {
            setError('Child date of birth is required');
            return;
        }
        if (childGender === '') {
            setError('Child gender is required');
            return;
        }
        const childData = {
            name: childName,
            dob: childDob,
            gender: childGender
        };
        onChildDataReceived(childData);
        console.log('Children data from child member', childData);
        setError('child' + ' ' + (keyChild + 1) + ' data assigned successfully');
    }
    return (
        <div key={keyChild}>
            <div key={keyChild} className='formMemberMainDiv'>
                <div className='nameDiv'>
                    <label>Name</label><br />
                    <input placeholder='Name*' type='text' onChange={(e) => handelChildNames(e)}
                        value={childName}></input>
                </div>
                <div className='nameDiv'>
                    <label>Date of birth*</label><br />
                    <input placeholder='Date of Birth' type='date' onChange={(e) => handleChildDateOfBirth(e)}
                        value={childDob}></input>
                </div>
                <div className='nameDiv'>
                    <label>Gender*</label><br />
                    <select onChange={(e) => handleChildGender(e)}>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                    </select>
                </div>
            </div>
            <div className='childMemberMainDiv'>
                <button type='submit'onClick={childButtonClicked}>Add Child {keyChild + 1}</button>
                {error && <p className='nameDiv errorDiv'>{error}</p>}
            </div>
        </div>
    );
}
function ChildrenArray({ length: length, onChildrenDataReceived: onChildrenDataReceived }) {
    const [childInfo, setChildInfo] = React.useState([]);
    const [error, setError] = React.useState('');
    const handelChildInfo = (info) => {
        setChildInfo(prevState => [...prevState, info]);
    }
    const childrenButtonClicked = () => {
        console.log('childrenInfo', childInfo);
        onChildrenDataReceived(childInfo);
        setError('children data assigned successfully');
    }
    return (
        <div>
            {[...Array(length).keys()].map((key) => <ChildMember key={key} keyChild={key} onChildDataReceived={handelChildInfo}  />)}
            {childInfo.length > 0 && childInfo.length === length && <button type='submit' onClick={() => childrenButtonClicked()}>Submit All Children</button>}
            {error && <p className='nameDiv errorDiv'>{error}</p>}
        </div>

    );
}
export default ChildrenArray;